<template>
  <card-list
    :title="title"
    :items="items"
    :height="height"
  >
    <template v-slot:default="listItem">
      <div class="text-lg">
        <div :class="[getColor(listItem.item), 'inline-block', 'mr-2', 'h-3', 'w-3', 'rounded']" />
        <li class="inline-block">{{ listItem.item.name }}</li>
      </div>
      <span class="inline-block font-bold text-2xl">{{ listItem.item.value }}</span>
    </template>
  </card-list>
</template>

<script>
import CardList from '@/Components/Cards/CardList'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: null
    }
  },
  components: { CardList },

  methods: {
    getColor(item) {
      return item?.color ? `bg-${item.color}` : null
    }
  }
}
</script>
